var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBgelement(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 159.73 137.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#68cbf4;}.cls-2,.cls-3{mix-blend-mode:multiply;}.cls-3{fill:#6a87c4;}.cls-4{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M109,25.45C81.57,28.56,67.66,7.1,49.15,6.5,31,5.9,20.5,21.72,26.94,47.21c7.32,29-6.43,43.69-5.15,67.28.53,9.93,10.43,24,22.7,22.68,16.12-1.77,22.64-20.31,36.89-33.09,12.78-11.46,35-19.41,48.44-27.78,13.13-8.19,28.64-14.15,29.87-31.77C160.5,32.86,150.16,20.79,109,25.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M139.51,86.47c-8.53,14-25.29,8.28-39.45,7-27.77-2.45-46.59,34.43-75.74,15.37C-8,87.76-8.13,49.41,24,34.67,113.78-6.56,147.26,73.76,139.51,86.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M11.44,132.18A.58.58,0,0,1,11,132a.57.57,0,0,1,0-.82l31.6-31.61a.58.58,0,0,1,.82.82L11.85,132A.58.58,0,0,1,11.44,132.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M58.11,35.07a.58.58,0,0,1-.41-.17.59.59,0,0,1,0-.82L91.61.17a.59.59,0,0,1,.83,0,.59.59,0,0,1,0,.82L58.52,34.9A.54.54,0,0,1,58.11,35.07Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgelement);
export default __webpack_public_path__ + "static/media/bgelement.6b77b17d8ed46508d3297ca29075cb24.svg";
export { ForwardRef as ReactComponent };